// src/utils/errorHandlers.js
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

/**
 * Custom toast for membership limit errors
 * @param {Error} error - The error object from the API
 * @returns {boolean} - True if it was a membership limit error, false otherwise
 */
export const handleMembershipLimitError = (error) => {
  // Check if it's a 403 error related to membership limits
  if (error.response && error.response.status === 403 && 
      error.response.data && error.response.data.detail && 
      error.response.data.detail.includes('polish limit')) {
    
    // Create a custom toast with a link to the membership page
    toast.error(
      <div>
        <p>You've used all your available polishes for this week.</p>
        <Link 
          to="/membership" 
          className="text-blue-600 hover:underline font-medium block mt-2"
        >
          Upgrade your membership for more polishes →
        </Link>
      </div>,
      {
        autoClose: false, // Don't auto-close this toast
        closeOnClick: false, // Don't close on click
        draggable: false, // Don't allow dragging
        closeButton: true, // Show close button
      }
    );
    return true;
  }
  return false;
};

const errorHandlers = {
  handleMembershipLimitError
};

export default errorHandlers;